/* ==========================================================================
   KOREDE バーチャル接客（コレデちゃん）renderer — 本番版
   - 右下フローティング起動（Inbox置換）。launcher は常駐・軽量。
   - scenario（接客の脳）と動画は初回オープン時に lazy-load（全ページの初期負荷を増やさない）。
   - 設定は section が window.KOREDE_CONCIERGE に注入する:
       { scenarioUrl, bustUrl, videoUrl, videoWebm, launcherTitle, launcherSub, assets:{name:url} }
   - ローカル参照の画像（taste-map.jpg / korede_left_all.png 等）は resolveAsset() が
     assets マップ経由で asset_url に解決する。scenario.json 側は無改変。
   - ロジックは mockups/korede-concierge/index.html と同一の会話エンジン。
   ========================================================================== */
(function(){
  var CFG = window.KOREDE_CONCIERGE || {};
  var root = document.getElementById('korede-concierge');
  if (!root) return;

  var panel   = root.querySelector('.kc-panel');
  var logEl   = root.querySelector('.kc__log');
  var choicesEl = root.querySelector('.kc__choices');
  var quickEl = root.querySelector('.kc__quick');
  var launcher = root.querySelector('.kc-launcher');
  var closeBtn = root.querySelector('.kc__close');

  /* AI チャット（2026-10-30 Sae「AIチャットに置き換える」）: 右下から普通に開いたときは AI チャット（iframe）。
     ギフト・おすそ分けの登録フォームと、商品ページの「味を選ぶ → 二段セリフ」など、開始ノードを指定して開く導線は
     AI にはできない処理なので、従来の選択式の案内のまま動かす。テーマ設定で AI を外すと全部従来に戻る。
     URL は KOREDE の公開チャット（下の AI_ORIGIN）ちょうどだけを受け付ける。
     iframe からは会話の中身を受け取らない。届くのは「準備できた / 閉じて / 商品カードを押した（商品キー）」の合図だけで、
     送り主（origin と iframe）を確かめてから使う。準備の合図が 8 秒来なければ、再読込か従来の案内を選べるようにする。 */
  var AI_ORIGIN = 'https://korede-concierge-728108815353.asia-northeast1.run.app';
  var aiUrl = (CFG.aiChatUrl === AI_ORIGIN + '/?embed=1') ? CFG.aiChatUrl : '';
  var aiFrame = null, aiReady = false, aiTimer = null, aiFallback = null, panelOpen = false;
  function aiFail(){
    // Only while the panel is open (set at once by open(), cleared at once by close()): a closed panel has no size to
    // place the notice by. Reopening restarts the watch.
    if (aiReady || aiFallback || !panelOpen || !root.classList.contains('kc-ai-mode')) return;
    track('ai_error', 'timeout');
    aiFallback = document.createElement('div');
    aiFallback.className = 'kc-ai-fail';
    aiFallback.innerHTML = '<p>ごめんなさい、いまうまくつながりませんでした。</p>';
    var retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'もう一度読み込む';
    var classic = document.createElement('button'); classic.type = 'button'; classic.textContent = 'いつもの案内を使う';
    retry.onclick = function(){ aiFallback.remove(); aiFallback = null; aiFrame.src = aiUrl; aiTimer = setTimeout(aiFail, 8000); };
    classic.onclick = function(){ aiFallback.remove(); aiFallback = null; aiUrl = ''; showAi(false); boot(); };
    aiFallback.appendChild(retry); aiFallback.appendChild(classic);
    // Start below the tabs, so 「よくある質問」 stays reachable while the AI is down.
    if (tabs && !tabs.hidden) aiFallback.style.top = (tabs.offsetTop + tabs.offsetHeight) + 'px';
    panel.appendChild(aiFallback);
  }
  /* 「AIに聞く」「よくある質問」の切り替え（Sae 2026-10-30「切り替えを付ける」）。AI が使えるときだけ出す。
     よくある質問 = 従来の選択式の案内（決まった答え・すぐ出る・AI の費用なし）。AI の会話は iframe ごと残すので、
     行き来しても消えない。商品ページの味の説明・ギフト・おすそ分けは従来の案内で開き、ここから AI に切り替えられる。 */
  var tabs = null, tabAi = null, tabGuide = null;
  function makeTabs(){
    if (tabs || !aiUrl) return;
    tabs = document.createElement('div');
    // A two-button switch (aria-pressed), not ARIA tabs: each is an ordinary button reached with Tab, pressed with Enter/Space.
    tabs.className = 'kc-tabs'; tabs.setAttribute('role', 'group'); tabs.setAttribute('aria-label', '表示の切り替え');
    function tab(text, ai){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kc-tab'; b.textContent = text;
      b.onclick = function(){
        if (root.classList.contains('kc-ai-mode') === ai) return;
        track('tab', ai ? 'ai' : 'guide');
        showAi(ai);
        if (!ai) boot();
      };
      tabs.appendChild(b); return b;
    }
    tabAi = tab('AIに聞く', true); tabGuide = tab('よくある質問', false);
    var head = panel.querySelector('.kc__head');
    if (head && head.nextSibling) panel.insertBefore(tabs, head.nextSibling); else panel.appendChild(tabs);
  }
  function syncTabs(){
    if (!tabs) return;
    var ai = root.classList.contains('kc-ai-mode');
    tabs.hidden = !aiUrl;
    tabAi.setAttribute('aria-pressed', ai ? 'true' : 'false');
    tabGuide.setAttribute('aria-pressed', ai ? 'false' : 'true');
  }
  function showAi(on){
    root.classList.toggle('kc-ai-mode', !!on);
    makeTabs(); syncTabs();
    if (!on){ clearTimeout(aiTimer); if (aiFallback){ aiFallback.remove(); aiFallback = null; } }
    if (on){ mountVideo(); }
    // Back to an AI frame that never said it was ready: watch it again.
    if (on && aiFrame && !aiReady){ clearTimeout(aiTimer); aiTimer = setTimeout(aiFail, 8000); }
    if (on && !aiFrame){
      aiFrame = document.createElement('iframe');
      aiFrame.className = 'kc-ai';
      aiFrame.title = 'コレデちゃんとお話（AI チャット）';
      aiFrame.src = aiUrl;
      aiFrame.setAttribute('referrerpolicy', 'no-referrer');
      panel.appendChild(aiFrame);
      aiTimer = setTimeout(aiFail, 8000);
    }
  }
  window.addEventListener('message', function(e){
    if (!aiFrame || e.origin !== AI_ORIGIN || e.source !== aiFrame.contentWindow) return;
    var m = e.data || {};
    if (m.type !== 'korede-chat') return;
    if (m.event === 'ready'){ aiReady = true; clearTimeout(aiTimer); if (aiFallback){ aiFallback.remove(); aiFallback = null; } }
    else if (m.event === 'close'){ close(true); }
    else if (m.event === 'unavailable'){ clearTimeout(aiTimer); aiFail(); }
    else if (m.event === 'card_click' && typeof m.key === 'string' && /^[a-z]{2,20}$/.test(m.key)){ track('card_click', m.key, 'ai'); }
  });

  var data = null;        // scenario（lazy load）
  var booted = false;     // 会話を開始済みか
  var pendingStart = null; // open(startId) で指定された開始ノード（boot 前に指定された場合に使う）
  var skip = false;
  var hintShown = false;

  /* ギフト受領者導線（/pages/gift）: QRカード → 専用エントリで自動オープン。
     ?registered=1 はメール登録フォーム送信後の戻り先（お礼ノードで再開）。 */
  var qsp = null;
  try { qsp = new URLSearchParams(location.search); } catch (e) {}
  var isGiftPage = /^\/pages\/gift\/?$/.test(location.pathname) || (qsp && qsp.get('src') === 'gift');
  var isGiftRegistered = isGiftPage && qsp && qsp.get('registered') === '1';
  /* おすそ分けカード導線（/pages/osusowake）: ギフトと同型の専用エントリ */
  var isOsusoPage = /^\/pages\/osusowake\/?$/.test(location.pathname) || (qsp && qsp.get('src') === 'osusowake');
  var isOsusoRegistered = isOsusoPage && qsp && qsp.get('registered') === '1';

  var sleep = function(ms){ return new Promise(function(r){ setTimeout(r, ms); }); };
  var scrollDown = function(){ logEl.scrollTop = logEl.scrollHeight; };

  /* 日本時間(JST=UTC+9)の「時」。端末のタイムゾーンに依存しない */
  function jstHour(){ return (new Date().getUTCHours() + 9) % 24; }

  /* 時間帯あいさつ（接客の入り。Sae=A確定。常にJST判定） */
  function greeting(){
    var h = jstHour();
    if (h >= 5 && h < 11) return 'おはようございます';
    if (h >= 11 && h < 18) return 'こんにちは';
    return 'こんばんは';
  }
  /* 創業からの年数（{years}）。JST の暦年で「暦年 − 創業年」= 2026 年は 5 年目、2027 年から自動で 6 年目（Sae 2026-09-21 指示）。
     創業年は section 設定 founded_year（既定 2021）。 */
  function yearsSince(){
    var jstYear = new Date(Date.now() + 9 * 3600 * 1000).getUTCFullYear();
    var founded = Number(CFG.foundedYear) || 2021;
    return Math.max(1, jstYear - founded);
  }
  function subst(text){
    return (text || '').replace(/\{greeting\}/g, greeting()).replace(/\{years\}/g, String(yearsSince()));
  }

  /* 起動ボタンの吹き出し用の短いあいさつ（常にJST判定） */
  function greetingShort(){
    var h = jstHour();
    if (h >= 5 && h < 11) return 'おはよう';
    if (h >= 11 && h < 18) return 'こんにちは';
    return 'こんばんは';
  }

  /* ローカル参照の資産名を theme asset の URL に解決（絶対URLはそのまま） */
  function resolveAsset(src){
    if (!src) return src;
    if (/^https?:\/\//.test(src) || src.charAt(0) === '/') return src;
    var name = src.split('/').pop();
    var map = CFG.assets || {};
    return map[name] || src;
  }

  /* 計測フック（個人情報なし）。dataLayer → GTM → GA4 の一本化。
     ※ gtag 直送は併用しない（GTMタグと二重計上になり、param キーも label/concierge_label で割れるため）。 */
  function track(event, label, value){
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'concierge_' + event, label: label || '', value: value || '' });
    } catch (e) {}
  }

  logEl.addEventListener('click', function(){ skip = true; });

  function botRow(){
    var row = document.createElement('div');
    row.className = 'row bot';
    row.innerHTML = '<div class="row__ava"></div>';
    var b = document.createElement('div');
    b.className = 'bubble';
    row.appendChild(b);
    logEl.appendChild(row);
    paintAvatars(row);
    scrollDown();
    return b;
  }

  async function typeMessage(text){
    text = subst(text);
    var b = botRow();
    b.innerHTML = '<span class="typing"><i></i><i></i><i></i></span>';
    var wait = skip ? 120 : 420;
    await sleep(wait);
    b.textContent = '';
    var caret = document.createElement('span'); caret.className = 'caret';
    for (var i = 0; i < text.length; i++){
      if (skip){ b.textContent = text; break; }
      b.textContent += text[i];
      b.appendChild(caret);
      scrollDown();
      var ch = text[i];
      await sleep(/[、。！？(^^)…]/.test(ch) ? 90 : 30);
    }
    if (caret.parentNode) caret.remove();
    scrollDown();
  }

  function showCard(card){
    var row = document.createElement('div');
    row.className = 'row bot';
    row.innerHTML = '<div class="row__ava"></div>';
    var c = document.createElement('div');
    c.className = 'card';
    var img = card.image ? '<img src="' + resolveAsset(card.image) + '" alt="">' : '';
    var isBlog = card.type === 'blog';
    var isLine = card.type === 'line';
    var tagCls = isLine ? 'tag line' : 'tag' + (isBlog ? ' blog' : '');
    var tagTxt = isLine ? 'LINE' : (isBlog ? 'BLOG' : 'PRODUCT');
    var ctaTxt = card.cta || (isBlog ? '記事を読む' : '商品を見る');
    c.innerHTML = img +
      '<div class="cbody"><span class="' + tagCls + '">' + tagTxt + '</span>' +
      '<h3>' + card.title + '</h3>' +
      (card.note ? '<p class="cnote">' + card.note + '</p>' : '') +
      '<a class="cta' + (isLine ? ' line' : '') + '" href="' + card.href + '" target="_blank" rel="noopener">' + ctaTxt + '</a></div>';
    var ctaEl = c.querySelector('.cta');
    if (ctaEl) ctaEl.addEventListener('click', function(){ track('card_click', card.title, card.href); });
    row.appendChild(c);
    logEl.appendChild(row);
    paintAvatars(row);
    scrollDown();
  }

  function showFlavorList(groups){
    var row = document.createElement('div');
    row.className = 'row bot wide';
    row.innerHTML = '<div class="row__ava"></div>';
    var box = document.createElement('div');
    box.className = 'flist';
    groups.forEach(function(g){
      var h = document.createElement('div');
      h.className = 'flist__grp';
      h.textContent = g.group;
      box.appendChild(h);
      g.items.forEach(function(it){
        var a = document.createElement('a');
        a.className = 'fitem';
        a.href = it.href; a.target = '_blank'; a.rel = 'noopener';
        var thumb = it.image ? '<img src="' + resolveAsset(it.image) + '" alt="">' : '<div class="fph">🍲</div>';
        a.innerHTML = thumb + '<div><b>' + it.name + '</b><span>' + it.desc + '</span></div>';
        a.addEventListener('click', function(){ track('flavor_click', it.name, it.href); });
        box.appendChild(a);
      });
    });
    row.appendChild(box);
    logEl.appendChild(row);
    paintAvatars(row);
    scrollDown();
  }

  function showMapImage(src){
    var row = document.createElement('div');
    row.className = 'row bot wide';
    row.innerHTML = '<div class="row__ava"></div>';
    var box = document.createElement('div');
    box.className = 'tmap';
    box.innerHTML = '<img src="' + resolveAsset(src) + '" alt="スープの味の分布図">';
    row.appendChild(box);
    logEl.appendChild(row);
    paintAvatars(row);
    scrollDown();
  }

  /* ギフト受領者のメール登録フォーム（Shopify customer フォームへ通常 POST）。
     - contact[tags] は送信時に JS で合成: gift_recipient(+ 任意の gift_from:名前)
     - 送信後は Shopify が return_to（/pages/gift?registered=1）へ戻す → gift_registered ノードで再開
     - 個人情報は dataLayer に載せない（track は送信イベントのみ） */
  function renderGiftForm(gf){
    var row = document.createElement('div');
    row.className = 'row bot wide';
    row.innerHTML = '<div class="row__ava"></div>';
    var box = document.createElement('form');
    box.className = 'kc-giftform';
    box.method = 'post';
    box.action = '/contact#korede-gift';
    box.innerHTML =
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="✓">' +
      '<input type="hidden" name="contact[tags]" value="' + (gf.tag || 'gift_recipient') + '">' +
      '<input type="hidden" name="return_to" value="' + (gf.returnTo || '/pages/gift?registered=1') + '">' +
      '<label class="kc-giftform__lbl">メールアドレス<em>必須</em></label>' +
      '<input class="kc-giftform__input" type="email" name="contact[email]" required autocomplete="email" placeholder="' + (gf.emailPlaceholder || 'メールアドレス') + '">' +
      '<label class="kc-giftform__lbl">' + (gf.fromLabel || 'どなたからの贈りものですか？') + '<em class="opt">任意</em></label>' +
      '<input class="kc-giftform__input" type="text" maxlength="30" data-gift-from placeholder="' + (gf.fromPlaceholder || 'お名前・ニックネーム（任意）') + '">' +
      '<button class="kc-giftform__submit" type="submit">' + (gf.submitLabel || 'クーポンを受け取る') + '</button>' +
      (gf.note ? '<p class="kc-giftform__note">' + gf.note + '</p>' : '');
    box.addEventListener('submit', function(){
      var from = box.querySelector('[data-gift-from]');
      var tags = box.querySelector('input[name="contact[tags]"]');
      var v = (from && from.value || '').replace(/[,\s]+/g, ' ').trim().slice(0, 30);
      if (v && tags) tags.value = (gf.tag || 'gift_recipient') + ',' + (gf.fromTagPrefix || 'gift_from') + ':' + v;
      track((gf.trackId || 'gift') + '_submit', v ? 'with_from' : 'no_from');
    });
    row.appendChild(box);
    logEl.appendChild(row);
    paintAvatars(row);
    scrollDown();
    /* Shopify storefront captcha は動的挿入フォームを自動バインドしない。
       protect() を呼ばないと submit が preventDefault されたまま送信不能になる
       （2026-07-07 ライブ検証で確認）。 */
    if (window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect){
      try { window.Shopify.captcha.protect(box); } catch (e) {}
    }
  }

  function userRow(text){
    var row = document.createElement('div');
    row.className = 'row user';
    var b = document.createElement('div');
    b.className = 'bubble';
    b.textContent = text;
    row.appendChild(b);
    logEl.appendChild(row);
    scrollDown();
  }

  /* バストアイコン（背景画像）を CFG から塗る */
  function paintAvatars(scope){
    if (!CFG.bustUrl) return;
    (scope || root).querySelectorAll('.row__ava').forEach(function(el){
      if (!el.style.backgroundImage) el.style.backgroundImage = "url('" + CFG.bustUrl + "')";
    });
  }

  function renderChoices(choices){
    choicesEl.innerHTML = '';
    (choices || []).forEach(function(c, i){
      var btn = document.createElement('button');
      btn.className = 'opt';
      btn.innerHTML = '<span class="n">' + (i + 1) + '</span>' + c.label;
      btn.onclick = function(){ track('choice', c.label, c.next); userRow(c.label); go(c.next); };
      choicesEl.appendChild(btn);
    });
  }

  async function go(id){
    var node = data && data.nodes[id];
    if (!node) return;
    track('node', id);
    if (!hintShown){
      hintShown = true;
      var h = document.createElement('div');
      h.className = 'skiphint';
      h.textContent = '💬 メッセージをタップすると早送りできます';
      logEl.appendChild(h);
    }
    skip = false;
    choicesEl.innerHTML = '';
    for (var i = 0; i < node.messages.length; i++){ await typeMessage(node.messages[i]); }
    if (node.flavors){ await sleep(skip ? 60 : 240); showFlavorList(node.flavors); }
    if (node.mapImage){ await sleep(skip ? 60 : 240); showMapImage(node.mapImage); }
    if (node.card){ await sleep(skip ? 60 : 240); showCard(node.card); }
    if (node.giftForm){ await sleep(skip ? 60 : 240); renderGiftForm(node.giftForm); }
    await sleep(skip ? 40 : 160);
    renderChoices(node.choices);
    scrollDown();
  }

  function renderQuick(){
    var q = data.meta && data.meta.quickFaq;
    if (!q || !q.length || !quickEl) return;
    quickEl.innerHTML = '';
    var lead = document.createElement('span');
    lead.className = 'qchip lead'; lead.textContent = 'よくある質問';
    quickEl.appendChild(lead);
    q.forEach(function(c){
      var b = document.createElement('button');
      b.className = 'qchip' + (c.all ? ' all' : '');
      b.textContent = c.label;
      b.onclick = function(){ track('quick', c.label, c.next); userRow(c.label); go(c.next); };
      quickEl.appendChild(b);
    });
  }

  function showError(){
    logEl.innerHTML =
      '<div class="kc__error">うまく読み込めませんでした。<br>お手数ですが時間をおいて開き直すか、' +
      '<a href="' + (CFG.siteUrl || 'https://korede.life') + '" target="_blank" rel="noopener">ストア</a>' +
      'からお問い合わせください。</div>';
  }

  /* 口パク動画要素を作る（軽量: webm 24KB / mp4 16KB。ミュート・インライン。ループしない） */
  function buildVideoEl(){
    if (!(CFG.videoUrl || CFG.videoWebm)) return null;
    var v = document.createElement('video');
    v.autoplay = true; v.muted = true; v.loop = false; v.playsInline = true;
    v.setAttribute('playsinline', ''); v.setAttribute('muted', ''); v.setAttribute('autoplay', '');
    if (CFG.bustUrl) v.poster = CFG.bustUrl;
    if (CFG.videoWebm) v.innerHTML += '<source src="' + CFG.videoWebm + '" type="video/webm">';
    if (CFG.videoUrl)  v.innerHTML += '<source src="' + CFG.videoUrl + '" type="video/mp4">';
    return v;
  }

  /* 約1.8秒だけ喋って、口を閉じた顔(先頭フレーム)で止める（ループのチラつき回避・話した風） */
  function playOnceThenRest(v, ms){
    if (!v) return;
    var rested = false;
    function rest(){ if (rested) return; rested = true; try { v.pause(); v.currentTime = 0; } catch (e) {} }
    var p = v.play(); if (p && p.catch) p.catch(function(){});
    setTimeout(rest, ms || 1800);
    v.addEventListener('ended', rest);
  }

  /* パネルヘッダーの動画（初回オープン時に差し込み） */
  function mountVideo(){
    var ava = root.querySelector('.kc__avatar');
    if (!ava || ava.dataset.mounted) return;
    ava.dataset.mounted = '1';
    var v = buildVideoEl();
    if (v){ ava.appendChild(v); playOnceThenRest(v, 1800); }
    else if (CFG.bustUrl){ ava.style.background = "#fff center/cover no-repeat url('" + CFG.bustUrl + "')"; }
  }

  async function boot(){
    if (booted) return;
    booted = true;
    mountVideo();
    paintAvatars();
    try {
      var url = CFG.scenarioUrl || './scenario.json';
      var res = await fetch(url, { credentials: 'omit' });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      data = await res.json();
    } catch (e){
      booted = false; // 次回オープンで再試行できるように
      showError();
      track('load_error', String(e && e.message || e));
      return;
    }
    renderQuick();
    var startId = data.start;
    if (pendingStart && data.nodes[pendingStart]) startId = pendingStart;
    else if (isOsusoRegistered && data.nodes.osusowake_registered) startId = 'osusowake_registered';
    else if (isOsusoPage && data.nodes.osusowake_welcome) startId = 'osusowake_welcome';
    else if (isGiftRegistered && data.nodes.gift_registered) startId = 'gift_registered';
    else if (isGiftPage && data.nodes.gift_welcome) startId = 'gift_welcome';
    pendingStart = null;
    go(startId);
    window.__korede_go = go; // テスト用ナビゲーションフック
  }

  /* ===== 開閉 =====
     open(startId): startId（文字列）を渡すと、その接客ノードから開く。
       未起動 → 開始ノードを差し替えて起動 / 起動済み → 会話の続きとしてそのノードへ。
     launcher クリック等の Event が渡っても無視する。 */
  function open(startId){
    var id = (typeof startId === 'string' && startId) ? startId : null;
    hideSay();
    root.classList.add('kc-open');
    panelOpen = true;
    clearTimeout(closeTimer);
    var useAi = !!aiUrl && !id && !isGiftPage && !isOsusoPage;
    showAi(useAi);
    // Same event name as before so open counts stay continuous; the value says which mode opened.
    track('open', id || '', useAi ? 'ai' : 'guide');
    if (useAi){ requestAnimationFrame(function(){ root.classList.add('kc-shown'); }); return; }
    // transition 用に1フレーム置いて表示クラス
    requestAnimationFrame(function(){ root.classList.add('kc-shown'); });
    if (id){
      if (booted && data){ go(data.nodes[id] ? id : data.start); }
      else pendingStart = id;
    }
    boot();
  }
  function openAt(id){ open(id); }
  var closeTimer = null;
  // focusLauncher: after the panel is gone and the launcher shows again, move focus back to it (closing from the AI frame).
  function close(focusLauncher){
    panelOpen = false;
    root.classList.remove('kc-shown');
    // Stop watching the AI frame while closed; open() → showAi(true) starts it again if it is still not ready.
    clearTimeout(aiTimer);
    track('close');
    clearTimeout(closeTimer);
    closeTimer = setTimeout(function(){
      root.classList.remove('kc-open');
      if (focusLauncher === true && launcher) launcher.focus();
    }, 200);
  }

  // 枠外タップで閉じるバックドロップを生成
  var backdrop = root.querySelector('.kc-backdrop');
  if (!backdrop) {
    backdrop = document.createElement('div');
    backdrop.className = 'kc-backdrop';
    root.appendChild(backdrop);
  }
  backdrop.addEventListener('click', close);

  /* ===== 商品ページ「味を選ぶ → コレデちゃんの二段セリフ」（案E・Sae 2026-09-18 確定 / 2026-09-21 実装 GO）
     一段目 = 一行説明（文字数連動 0.5 秒 + 文字数÷6 秒、4〜7 秒）→ 二段目「もっと知りたい？」3 秒 → 約 1 秒で消える。
     吹き出し/顔タップ = その味の taste_<key>_intro から開く。消えた後に顔タップ = taste_continue_<key>（「もっと知りたいですか？」）。
     味ノードが無い味・味未選択・別ページは従来どおり root から。
     入力 = 商品ページ JS（product-korede-soup.js）が発火する CustomEvent 'korede:flavorchange'
            detail = { product:'soup', flavor:'きのこチーズ', comment:'一行説明' } */
  var SAY_CPS = 6, SAY_MIN_MS = 4000, SAY_MAX_MS = 7000, SAY_STAGE2_MS = 3000;
  /* 味名（バリアントのオプション値）→ 接客ノードの key。商品ライン別（スープ / シェイク / カレー）。部分一致で引く。
     載っていない味（例: レモン牛乳 = 今期終了）は吹き出しを出さない。差し替えは CFG.tasteNodes（{product:{味名:key}}）。 */
  var TASTE_KEYS = CFG.tasteNodes || {
    soup:  { 'きのこ': 'kinoko', 'コーン': 'corn', 'かぼちゃ': 'pumpkin', 'お芋': 'imo', 'オニオン': 'onion',
             'クラム': 'clam', 'ほうれん草': 'spinach', 'トマト': 'tomato' },
    shake: { '緑茶': 'greentea', '黒ごま': 'goma', '黒ゴマ': 'goma', 'ヨーグルト': 'yogurt', 'ソイラテ': 'soylatte',
             'ほうじ': 'houji', '焙じ': 'houji' },
    curry: { '完全': 'comp', 'スパイス': 'spice' }
  };
  function tasteKey(product, flavor){
    var table = TASTE_KEYS[product || 'soup'] || {};
    var f = String(flavor || '');
    if (table[f]) return table[f];
    var names = Object.keys(table);
    for (var i = 0; i < names.length; i++){ if (f.indexOf(names[i]) >= 0) return table[names[i]]; }
    return null;
  }
  /* 一言目のセリフ（ページの一行説明を「ですます」のセリフ調にしたもの。内容は一行説明と同じ・Sae 2026-09-21 指示）。
     見つからない味は data-comment をそのまま使う。差し替えは CFG.tasteSay（key → 文）。 */
  var SAY_LINES = CFG.tasteSay || {
    corn:    'やさしい甘みで、朝食やお子さまにも合わせやすい定番フレーバーです。',
    pumpkin: '自然な甘みとコクがあって、朝食や軽めのランチにも合わせやすい味です。',
    imo:     'さつまいものやさしい甘みで、冷製でも取り入れやすい味です。',
    onion:   '玉ねぎの甘みと香ばしさがあって、パンやごはんにも合わせやすい味です。',
    clam:    '貝の旨みとクリーミーさがあって、満足感がほしい時におすすめです。',
    kinoko:  'きのこの香りとチーズのコクで、しっかりめの味が好きな方におすすめです。',
    spinach: 'ガーリック感のある食事系で、甘くない味を求める方におすすめです。',
    tomato:  'トマトの酸味とピリッとした辛みで、気分を変えたい時におすすめです。',
    greentea: '粉末茶のような、甘くない濃い味の緑茶です。冷製がおすすめですよ。',
    goma:     '黒ごまをたっぷり使った濃厚なプロテインです。牛乳で作ると黒ごまラテになりますよ。',
    yogurt:   'さっぱりした酸味で、牛乳や豆乳にも合わせやすい味です。',
    soylatte: 'ほのかな甘みのソイラテです。牛乳や豆乳で作るのがおすすめですよ。',
    houji:    '緑茶よりも濃厚なほうじ茶プロテインです。ラテ風に作るのもおすすめですよ。',
    comp:     '26種類の栄養素で、辛さは激辛。スパイスカレーに比べて少し淡白な味わいです。',
    spice:    '19種類の栄養素で、完全プロカレーよりも味重視、スパイス感が強めです。'
  };
  var SAY_NOTE = 'もっと知りたい場合は聞いてくださいね！';   // 説明中にタップされた時の短い一言（3 秒 → 消える）
  var sayEl = null, sayT1 = null, sayT2 = null, sayDocHandler = null, lastFlavor = null, sayStage = 0;
  function stage1Ms(text){
    var n = String(text || '').replace(/\s/g, '').length;
    return Math.min(SAY_MAX_MS, Math.max(SAY_MIN_MS, Math.round(500 + n / SAY_CPS * 1000)));
  }
  function hideSay(){
    if (!sayEl) return;
    clearTimeout(sayT1); clearTimeout(sayT2);
    sayStage = 0;
    sayEl.classList.remove('on');
    if (sayDocHandler){ document.removeEventListener('click', sayDocHandler, true); sayDocHandler = null; }
  }
  function ensureSayEl(){
    if (sayEl) return sayEl;
    sayEl = document.createElement('div');
    sayEl.className = 'kc-say';
    sayEl.setAttribute('role', 'status');
    root.appendChild(sayEl);
    sayEl.addEventListener('click', function(ev){
      ev.stopPropagation();
      if (!lastFlavor) { hideSay(); return; }
      if (sayStage === 1) { showNote(); return; }   // 説明中のタップ = 消して短い一言へ（開かない）
      track('taste_more', lastFlavor.name, lastFlavor.node);
      open(lastFlavor.node);
    });
    return sayEl;
  }
  /* 説明（一段目）の途中でタップされた時: 長い説明を消し、「もっと知りたい場合は聞いてくださいね！」を 3 秒だけ出す */
  function showNote(){
    if (!sayEl || sayStage !== 1) return;
    clearTimeout(sayT1); clearTimeout(sayT2);
    sayStage = 2;
    sayEl.innerHTML = '<span class="who">コレデちゃん</span>' + SAY_NOTE;
    if (lastFlavor) track('taste_dismiss', lastFlavor.name, lastFlavor.node);
    sayT2 = setTimeout(hideSay, SAY_STAGE2_MS);
  }
  function showSay(flavor, comment, product){
    var key = tasteKey(product, flavor);
    if (!key || !launcher) return;
    var el = ensureSayEl();
    lastFlavor = { name: String(flavor), key: key, node: 'taste_' + key + '_intro', cont: 'taste_continue_' + key };
    hideSay();
    var said = SAY_LINES[key] || comment;
    var line = said ? ('『' + flavor + '』は、' + said) : ('『' + flavor + '』ですね。');
    var t1 = stage1Ms(line);
    sayStage = 1;
    el.innerHTML = '<span class="who">コレデちゃん</span>';
    el.appendChild(document.createTextNode(line));
    void el.offsetWidth; el.classList.add('on');
    track('taste_say', String(flavor), String(t1));
    sayT1 = setTimeout(function(){
      sayStage = 2;
      el.innerHTML = '<span class="who">コレデちゃん</span>もっと知りたい？ <span class="more">タップして聞く ▸</span>';
    }, t1);
    sayT2 = setTimeout(hideSay, t1 + SAY_STAGE2_MS);
    // 表示のきっかけになったタップは無視。次のタップ（どこでも）= 説明中なら短い一言へ、二段目なら消す
    setTimeout(function(){
      sayDocHandler = function(ev){
        if (el.contains(ev.target) || launcher.contains(ev.target)) return;
        if (sayStage === 1) showNote(); else hideSay();
      };
      document.addEventListener('click', sayDocHandler, true);
    }, 0);
  }
  document.addEventListener('korede:flavorchange', function(ev){
    var d = (ev && ev.detail) || {};
    showSay(d.flavor, d.comment || '', d.product || 'soup');
  });
  function onLauncherClick(){
    if (sayEl && sayEl.classList.contains('on') && lastFlavor){
      track('taste_more', lastFlavor.name, lastFlavor.node);
      open(lastFlavor.node);
      return;
    }
    if (lastFlavor){
      track('taste_continue', lastFlavor.name, lastFlavor.cont);
      open(lastFlavor.cont);
      return;
    }
    open();
  }
  window.KOREDE_CONCIERGE_API = { open: open, openAt: openAt, say: showSay, close: close };

  if (launcher) launcher.addEventListener('click', onLauncherClick);
  if (closeBtn) closeBtn.addEventListener('click', close);
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape' && root.classList.contains('kc-open')) close(true);
  });

  // launcher の顔＝口パク動画（軽量・1.8秒で口を閉じた顔に停止）。動画が無ければ静止画
  var lava = root.querySelector('.kc-launcher__ava');
  var lv = null;
  if (lava) {
    lv = buildVideoEl();
    if (lv) { lava.appendChild(lv); playOnceThenRest(lv, 1800); }
    else if (CFG.bustUrl) { lava.style.backgroundImage = "url('" + CFG.bustUrl + "')"; }
  }

  // あいさつ吹き出し：このサイト訪問の【初回ページのみ】表示。
  //   あいさつ(5秒)＋口パク → 案内(7秒)＋口パク → 非表示。次ページ以降は出さない。
  var kcGreeted = false;
  try { kcGreeted = sessionStorage.getItem('kc_greeted') === '1'; } catch (e) {}
  if (launcher && !kcGreeted && !launcher.querySelector('.kc-launcher__hello')) {
    try { sessionStorage.setItem('kc_greeted', '1'); } catch (e) {}
    var lhello = document.createElement('span');
    lhello.className = 'kc-launcher__hello';
    lhello.textContent = greeting() + '！';
    launcher.appendChild(lhello);
    setTimeout(function(){
      lhello.textContent = 'お困り事があればお呼びください';
      if (lv) { lv.currentTime = 0; playOnceThenRest(lv, 1800); }
    }, 5000);
    setTimeout(function(){ lhello.classList.add('kc-hide'); }, 12000);
  }

  // section 設定で自動オープン指定があれば。ギフト着地（/pages/gift）は常に自動オープン
  if (CFG.autoOpen) open();
  else if (isGiftPage || isOsusoPage) setTimeout(open, 500);
})();
